/** Statuses that mean this exact document already had signing invites emailed. */
const INVITES_SENT_STATUSES = new Set([
  'sent',
  'partial',
  'buyers_complete',
  'buyers_complete_delivered',
  'completing',
  'awaiting_signed_pdf',
  'awaiting_analysis',
  'awaiting_tms',
  'awaiting_completion_email',
]);

export function signerEmailIsLocked(signer) {
  return Boolean(signer && signer.email_locked);
}

export function signingInvitesWereSent({
  sendOk,
  inklessInvitesSent,
  inklessSessionStatus,
} = {}) {
  if (sendOk) return true;
  if (typeof inklessInvitesSent === 'boolean') return inklessInvitesSent;
  return INVITES_SENT_STATUSES.has(inklessSessionStatus);
}
